import ms from 'ms'
import { useQuery } from '@tanstack/react-query'
import type { QueryClient } from '@tanstack/react-query'
import type { GetConversationResponse } from '../gen/service/creativefabrica/studioagent/v1/service_pb'
import { getConversationFn } from '../gen/service/creativefabrica/studioagent/v1'
import { normalizeTurnState } from '../utils/normalize'
import { aidaChatKeys } from '../constants/query-keys'

export function conversationQueryOptions(conversationId: string | null) {
  return {
    queryKey: aidaChatKeys.conversation(conversationId ?? ''),
    queryFn: () => {
      if (!conversationId) {
        throw new Error('useConversationQuery called without a conversation id')
      }
      return getConversationFn({ conversationId })
    },
    enabled: Boolean(conversationId),
    refetchInterval: (query: { state: { data?: GetConversationResponse } }) =>
      query.state.data?.conversation?.busy ? ms('2.5s') : false,
  }
}

export function useConversationQuery(conversationId: string | null) {
  return useQuery({
    ...conversationQueryOptions(conversationId),
    select: normalizeTurnState,
  })
}

export function setConversationBusy(
  queryClient: QueryClient,
  conversationId: string,
  busy: boolean,
) {
  queryClient.setQueryData<GetConversationResponse>(
    aidaChatKeys.conversation(conversationId),
    current =>
      current?.conversation
        ? { ...current, conversation: { ...current.conversation, busy } }
        : current,
  )
}
